export type PaperOrientation = 'portrait' | 'landscape'

export namespace PaperOrientation {
  export function is(value: unknown): value is PaperOrientation {
    return typeof value === 'string' && (value === 'portrait' || value === 'landscape')
  }
}
